<template>
    <div class="container-fluid ghost-mode">
        <div class="row" @click="hideGhostMode" style="height: 100%;">
            <div class="offset-11 col-1 text-right text-light">
                <h1 class="font-weight-bold hide-ghost-mode pt-5" style="cursor: pointer;">
                    <i class="fas fa-times"></i>
                </h1>
            </div>
        </div>
        <slot>
            This will only be displayed if no html content was sent
        </slot>
    </div>
</template>

<script>
import { eventBus } from '@/main'

export default {
    name: "GhostMode",
    methods: {
        hideGhostMode() {
            this.mutateShowGhostMode = false;
            eventBus.hideGhostMode(this.mutateShowGhostMode)
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body; // select body element
            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        }
    },
    mounted() {
        this.toggleBodyClass('addClass', 'no-movement');
    },
    destroyed() {
        this.toggleBodyClass('removeClass', 'no-movement');
    }
}
</script>